import LabelLanding from './LabelLanding'

export default LabelLanding;